import { GroupedNotification } from "@/pages/rollshop/models/RollshopNotification";
import { Deselect, DoneAll, RemoveDone } from "@mui/icons-material";
import { Box, Button, IconButton, Paper, Typography } from "@mui/material";

export const ActionsHeader = ({
	selectedRows,
	handleClearSelection,
	handleMultipleAcknowledge,
	handleMultipleUnacknowledge,
	isLoading,
}: {
	selectedRows: GroupedNotification[];
	handleClearSelection: () => void;
	handleMultipleAcknowledge: () => void;
	handleMultipleUnacknowledge: () => void;
	isLoading: boolean;
}) => {
	return (
		<Paper
			elevation={2}
			sx={{
				px: 1,
				py: 0.5,
				mb: 0.5,
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
				<IconButton
					size="small"
					onClick={handleClearSelection}
					title="Deselect All"
				>
					<Deselect fontSize="small" />
				</IconButton>
				<Typography variant="body2" color="text.secondary" fontWeight={500}>
					{selectedRows.length} selected
				</Typography>
			</Box>
			<Box sx={{ display: "flex", gap: 0.5 }}>
				<Button
					data-test-id="acknowledge-all-button"
					variant="outlined"
					size="small"
					startIcon={<DoneAll />}
					onClick={handleMultipleAcknowledge}
					disabled={
						isLoading || selectedRows.every((r) => r.StatusCode !== "P")
					}
					sx={{
						fontSize: "0.75rem",
						py: 0.5,
						px: 1.5,
						textTransform: "none",
					}}
				>
					Acknowledge All
				</Button>
				<Button
					data-test-id="unacknowledge-all-button"
					variant="outlined"
					size="small"
					startIcon={<RemoveDone />}
					onClick={handleMultipleUnacknowledge}
					disabled={
						isLoading || selectedRows.every((r) => r.StatusCode !== "A")
					}
					sx={{
						fontSize: "0.75rem",
						py: 0.5,
						px: 1.5,
						textTransform: "none",
					}}
				>
					Unacknowledge All
				</Button>
			</Box>
		</Paper>
	);
};
